import { render, staticRenderFns } from "./comp_ProductCard-LeftAlignedWithBtnFeatured.vue?vue&type=template&id=4253565c&scoped=true&"
import script from "./comp_ProductCard-LeftAlignedWithBtnFeatured.vue?vue&type=script&lang=js&"
export * from "./comp_ProductCard-LeftAlignedWithBtnFeatured.vue?vue&type=script&lang=js&"
import style0 from "./comp_ProductCard-LeftAlignedWithBtnFeatured.vue?vue&type=style&index=0&id=4253565c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4253565c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VHover,VSpacer})
